import { render, staticRenderFns } from "./PostOfficePackage.vue?vue&type=template&id=5835bd06&scoped=true&"
import script from "./PostOfficePackage.vue?vue&type=script&lang=js&"
export * from "./PostOfficePackage.vue?vue&type=script&lang=js&"
import style0 from "./PostOfficePackage.vue?vue&type=style&index=0&id=5835bd06&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5835bd06",
  null
  
)

export default component.exports